var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/logo-square-white.269df8ab.png","uri@2x": __webpack_public_path__ + "static/media/logo-square-white.269df8ab.png","uri@3x": __webpack_public_path__ + "static/media/logo-square-white.929a310e.png",
    width: 116,
    height: 118
});